// Shared media (not translated)
export const media = {
  hero: "https://images.unsplash.com/photo-1716467278688-5b7fc38e3ca7?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400",
  aboutMain: "https://images.unsplash.com/photo-1747545806166-d1c5ee3d796a?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  aboutSecondary: "https://images.pexels.com/photos/7232397/pexels-photo-7232397.jpeg?auto=compress&cs=tinysrgb&w=1200",
  investment: "https://images.unsplash.com/photo-1758188753373-5b01a0fc6d9d?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  gallery: {
    camera: "https://images.pexels.com/photos/13722944/pexels-photo-13722944.jpeg?auto=compress&cs=tinysrgb&w=1200",
    bagno: "https://images.unsplash.com/photo-1753605788101-04d1e653e74a?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    living: "https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tessili: "https://images.pexels.com/photos/7232405/pexels-photo-7232405.jpeg?auto=compress&cs=tinysrgb&w=1200",
    lenzuola: "https://images.unsplash.com/photo-1663811397216-8073705919cd?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    tende: "https://images.unsplash.com/photo-1573507811472-909cd17e834d?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    cuscini: "https://images.unsplash.com/photo-1615800001964-5afd0ae8e49a?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    complementi: "https://images.unsplash.com/photo-1631125915902-d8abe9225ff2?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
  },
  testimonials: [
    "https://images.unsplash.com/photo-1665327474695-8609946be727?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    "https://images.unsplash.com/photo-1609436132311-e4b0c9370469?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    "https://images.unsplash.com/photo-1764971591006-b6eb67a8f0cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    "https://images.unsplash.com/photo-1533778222324-be782ae129e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  ],
};

export const contacts = {
  email: "eurostyle@hotmail.com",
  phoneDisplay: "02 9008231",
  phoneTel: "+39029008231",
  whatsappNumber: "39029008231",
  whatsappMessage: {
    it: "Ciao Home Zen, sono interessato al franchising. Potreste darmi maggiori informazioni?",
    en: "Hi Home Zen, I'm interested in the franchise. Could you send me more information?",
    zh: "您好 Home Zen,我对特许经营感兴趣,能否提供更多信息?",
  },
  brochure: "/brochure-zen-home.pdf",
  address: "C.C. Il Girasole, Padiglione 14 — 20084 Lacchiarella (MI)",
  mapLat: 45.3236,
  mapLon: 9.1381,
  vat: "07859080967",
  social: {
    instagram: "https://www.instagram.com/eurostylebiancheriacasa?igsh=ODhtbjJzbW95OGdx",
    tiktok: "https://www.tiktok.com/@homezentextile?_r=1&_t=ZN-97pg8bnP2UY",
    amazon:
      "https://www.amazon.it/stores/HOMEZENHOUSEHOLDLINEN/page/FB73E48B-AE30-42A6-B69F-63B75E605BCB?lp_asin=B0DZJTZ3ZY&ref_=cm_sw_r_apin_ast_store_8TFASQDDEZTQ7FK99PPR&store_ref=bl_ast_dp_brandlogo_sto&bl_grd_status=override",
  },
};

export const languages = [
  { code: "it", label: "IT", name: "Italiano" },
  { code: "en", label: "EN", name: "English" },
  { code: "zh", label: "中文", name: "中文" },
];

export const content = {
  it: {
    nav: {
      about: "Chi Siamo",
      why: "Perché Zen",
      how: "Come Funziona",
      format: "Format",
      gallery: "Galleria",
      investment: "Investimento",
      contact: "Contatti",
      cta: "Richiedi informazioni",
    },
    hero: {
      kicker: "Franchising · Vivere essenziale",
      title: "Apri il tuo punto vendita Home Zen.",
      subtitle:
        "Il franchising dedicato alla casa, al tessile e alla biancheria che unisce design, qualità e redditività.",
      ctaPrimary: "Richiedi informazioni",
      ctaSecondary: "Scarica la brochure",
      scroll: "Scorri",
    },
    about: {
      kicker: "Chi Siamo",
      motto: "Meno, ma meglio.",
      title: "La bellezza del vivere essenziale.",
      body: [
        "Home Zen nasce da un'idea semplice: la casa dovrebbe essere un luogo di calma, non di eccesso. Selezioniamo tessili, biancheria e complementi d'arredo capaci di durare nel tempo, invecchiando con grazia.",
        "Materiali naturali, palette calde, cura maniacale del dettaglio. Ogni prodotto è pensato per portare equilibrio negli spazi e serenità nelle giornate.",
      ],
      values: [
        { title: "Vivere essenziale", text: "Meno oggetti, più significato. Spazi che respirano." },
        { title: "Materiali naturali", text: "Lino, cotone, ceramica e legno che raccontano una storia." },
        { title: "Qualità che dura", text: "Prodotti pensati per accompagnarti per anni, non per stagioni." },
        { title: "Cura dei dettagli", text: "Ogni cucitura, ogni finitura, studiata con precisione." },
      ],
    },
    why: {
      kicker: "Perché aprire un franchising",
      title: "Un format già collaudato, pronto per te.",
      subtitle:
        "Ti affianchiamo in ogni fase con un modello sostenibile e un marchio che i clienti amano.",
      items: [
        { icon: "Sparkle", title: "Brand riconoscibile", text: "Un'identità forte e coerente, amata dai clienti." },
        { icon: "Blueprint", title: "Format collaudato", text: "Un modello di negozio testato e replicabile." },
        { icon: "Handshake", title: "Supporto completo", text: "Al tuo fianco dall'apertura e ogni giorno dopo." },
        { icon: "Megaphone", title: "Marketing", text: "Campagne, materiali e strategie pronte all'uso." },
        { icon: "GraduationCap", title: "Formazione", text: "Percorsi dedicati per te e il tuo team." },
        { icon: "SealCheck", title: "Nessuna esperienza richiesta", text: "Ti insegniamo tutto ciò che serve." },
        { icon: "ShoppingBag", title: "Centrale acquisti", text: "Condizioni vantaggiose e logistica curata." },
        { icon: "Storefront", title: "Visual merchandising", text: "Allestimenti eleganti definiti nel dettaglio." },
        { icon: "Headset", title: "Assistenza continua", text: "Un referente sempre a tua disposizione." },
      ],
    },
    how: {
      kicker: "Come funziona",
      title: "Sei passi verso il tuo negozio.",
      steps: [
        { n: "01", title: "Richiesta informazioni", text: "Compili il form e ci racconti la tua ambizione." },
        { n: "02", title: "Primo colloquio", text: "Ci conosciamo e valutiamo insieme il progetto." },
        { n: "03", title: "Analisi della location", text: "Studiamo la piazza migliore per il tuo punto vendita." },
        { n: "04", title: "Firma del contratto", text: "Definiamo termini chiari e trasparenti." },
        { n: "05", title: "Formazione", text: "Prepariamo te e il tuo team all'apertura." },
        { n: "06", title: "Apertura negozio", text: "Inauguriamo insieme la tua nuova avventura." },
      ],
    },
    turnkey: {
      kicker: "Format negozio",
      title: "Scaffalature incluse. Brand incluso.",
      subtitle:
        "Ti forniamo un negozio pronto all'apertura: espositori modulari brandizzati Home Zen, allestimento studiato al centimetro e assistenza al montaggio.",
      bullets: [
        { title: "Scaffalature modulari", text: "Sistema espositivo scalabile, adattabile a metrature da 80 a 120 mq." },
        { title: "Grafica brandizzata", text: "Testate, insegne e comunicazione visiva coerenti con l'identità Home Zen." },
        { title: "Layout personalizzato", text: "Progettiamo la disposizione insieme a te, sulla base della tua location." },
        { title: "Montaggio & visual", text: "Ti affianchiamo dal montaggio all'allestimento merceologico." },
      ],
      before: "Prima",
      after: "Dopo",
      dragHint: "Trascina per confrontare",
      cta: "Richiedi il preventivo espositori",
    },
    investment: {
      kicker: "Investimento",
      title: "Un modello pensato per essere sostenibile.",
      body:
        "Abbiamo costruito un format equilibrato, dove ogni voce ha un senso preciso e un ritorno misurabile. Trasparenza totale, nessuna sorpresa.",
      items: [
        { title: "Fee d'ingresso", text: "Un accesso chiaro al marchio, al know-how e al metodo Home Zen." },
        { title: "Royalties", text: "Commisurate ai risultati, per crescere insieme in modo equo." },
        { title: "Formazione", text: "Inclusa e continua, per te e per chi lavora con te." },
        { title: "Assistenza", text: "Supporto costante su gestione, acquisti e merchandising." },
      ],
      note: "Le cifre le condividiamo durante il colloquio, sul tuo progetto specifico.",
    },
    gallery: {
      kicker: "Galleria",
      title: "Ogni angolo, un'esperienza.",
      categories: {
        camera: "Camera",
        bagno: "Bagno",
        living: "Living",
        tessili: "Tessili",
        lenzuola: "Lenzuola",
        tende: "Tende",
        cuscini: "Cuscini",
        complementi: "Complementi",
      },
    },
    stats: {
      kicker: "I numeri",
      title: "Numeri che raccontano fiducia.",
      items: [
        { value: 5000, suffix: "+", label: "Clienti soddisfatti" },
        { value: 98, suffix: "%", label: "Soddisfazione" },
        { value: 20, suffix: "", label: "Anni di esperienza" },
        { value: 100, suffix: "%", label: "Supporto dedicato" },
      ],
    },
    testimonials: {
      kicker: "Testimonianze",
      title: "Le voci di chi ha scelto Home Zen.",
      items: [
        { name: "Marco Bellini", role: "Affiliato · Milano", quote: "In un anno il negozio è diventato un punto di riferimento del quartiere. Il supporto è costante e concreto." },
        { name: "Giulia Ferrara", role: "Affiliata · Bologna", quote: "Non avevo esperienza nel retail. La formazione Home Zen mi ha resa autonoma e sicura fin dal primo giorno." },
        { name: "Alessandro Conti", role: "Affiliato · Torino", quote: "Un brand elegante che i clienti riconoscono e amano. La centrale acquisti fa davvero la differenza." },
        { name: "Sara Moretti", role: "Affiliata · Firenze", quote: "Ho trovato molto più di un franchising: un metodo, una famiglia e una redditività reale." },
      ],
    },
    faq: {
      kicker: "FAQ",
      title: "Domande frequenti.",
      items: [
        { q: "Quanto spazio serve per il negozio?", a: "Il format è pensato per superfici da circa 80 a 120 mq, in posizioni ad alta visibilità e passaggio." },
        { q: "Come funziona la selezione dei prodotti?", a: "Tramite la centrale acquisti: assortimenti curati, condizioni vantaggiose e logistica gestita da noi." },
        { q: "Quali sono i tempi per aprire?", a: "Dipendono dalla location, ma il nostro processo in sei passi è pensato per essere rapido e ordinato." },
      ],
    },
    news: {
      kicker: "Magazine",
      title: "News, storie e download.",
      posts: [
        { tag: "News", title: "Home Zen apre a Verona", text: "Il nuovo punto vendita porta il vivere essenziale nel cuore della città." },
        { tag: "Blog", title: "L'arte del lino naturale", text: "Perché scegliamo fibre naturali e come invecchiano con grazia." },
        { tag: "Blog", title: "Progettare spazi che respirano", text: "Cinque principi per una casa più calma ed essenziale." },
      ],
      download: {
        title: "Area Download",
        text: "Scarica la brochure completa del franchising Home Zen in formato PDF.",
        cta: "Scarica la brochure",
      },
    },
    map: {
      kicker: "Punto vendita",
      title: "Dove trovarci.",
      subtitle: "Ci trovi a Milano, nella nostra sede.",
      addressLabel: "Indirizzo",
      cta: "Ottieni indicazioni",
      stores: ["Milano"],
    },
    contact: {
      kicker: "Contatti",
      title: "Iniziamo a costruire il tuo negozio.",
      subtitle: "Raccontaci il tuo progetto: ti ricontattiamo entro 48 ore.",
      fields: {
        name: "Nome e cognome",
        phone: "Telefono",
        email: "Email",
        province: "Provincia",
        budget: "Disponibilità di investimento",
        message: "Il tuo messaggio",
      },
      budgetOptions: ["Da definire", "Fino a 50.000 €", "50.000 – 100.000 €", "Oltre 100.000 €"],
      privacy: "Ho letto e accetto la Privacy Policy e il trattamento dei dati.",
      submit: "Invia richiesta",
      callback: "Richiedi di essere richiamato",
      success: "Grazie! Apriamo il tuo client email per completare l'invio.",
      privacyError: "Per procedere accetta la Privacy Policy.",
    },
    footer: {
      tagline: "Il vivere essenziale, in franchising.",
      explore: "Esplora",
      legal: "Legale",
      contactTitle: "Contatti",
      social: "Seguici",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      rights: "Tutti i diritti riservati.",
      vatLabel: "P. IVA",
    },
    floating: {
      call: "Chiama ora",
      book: "Prenota una consulenza",
      whatsapp: "Scrivici su WhatsApp",
    },
    affiliates: {
      linkLabel: "Area Affiliati",
      kicker: "Area riservata",
      title: "Bentornato, affiliato.",
      subtitle:
        "L'area privata dedicata alla rete Home Zen: brochure, listini, campagne del mese e comunicazioni interne.",
      logout: "Esci",
      gate: {
        kicker: "Accesso riservato",
        title: "Area Affiliati Home Zen.",
        subtitle:
          "Inserisci la password ricevuta via WhatsApp. Se non l'hai ancora, scrivici al numero della sede.",
        placeholder: "Password",
        submit: "Entra",
        error: "Password errata. Riprova o contattaci.",
        contactHelp: "Non hai la password? Scrivici",
      },
      sections: {
        downloads: "Download & materiali",
        campaigns: "Campagne del mese",
        news: "News interne",
        kit: "Social Kit",
        purchasing: "Centrale acquisti",
      },
      downloads: {
        subtitle: "Documenti ufficiali sempre aggiornati.",
        items: [
          { key: "brochure", title: "Brochure franchising", desc: "Il documento completo con format, materie, valori e piano.", href: "/brochure-zen-home.pdf", available: true },
          { key: "pricelist", title: "Listino prodotti", desc: "Riservato agli affiliati. In arrivo dopo la firma.", available: false },
          { key: "contract", title: "Contratto tipo", desc: "Bozza contratto franchising editabile.", available: false },
          { key: "media", title: "Media kit", desc: "Logo, palette, font e immagini ad alta risoluzione.", available: false },
        ],
      },
      campaigns: {
        subtitle: "Materiali marketing pronti da personalizzare.",
        items: [
          { tag: "In corso", title: "Autunno · Vivere essenziale", text: "Vetrina + campagna social dedicata alle materie naturali di stagione." },
          { tag: "Prossima", title: "Natale · Regali che restano", text: "Boxset lino + candele, in uscita a novembre." },
          { tag: "Sempre attiva", title: "Franchise Story", text: "Serie di reel con storie di affiliati per attrarre nuovi partner." },
        ],
      },
      news: {
        subtitle: "Comunicazioni riservate alla rete.",
        items: [
          { date: "07 · 2026", title: "Nuovo negozio Home Zen a Verona", text: "Apertura confermata il 15 luglio. Preparate la comunicazione locale." },
          { date: "07 · 2026", title: "Aggiornamento centrale acquisti", text: "Nuovi assortimenti lino disponibili da lunedì prossimo. Ordini aperti." },
          { date: "06 · 2026", title: "Formazione visual merchandising", text: "Prossimo webinar il 30/06 alle 15:00. Iscrizioni via WhatsApp." },
        ],
      },
      kit: {
        subtitle: "12 post + 15 storie + 3 reel pronti per Instagram e TikTok.",
        cta: "Apri il Social Kit",
      },
      purchasing: {
        subtitle: "Contatto diretto per ordini e assortimenti.",
        emailLabel: "Email ordini",
        whatsappLabel: "WhatsApp centrale",
      },
    },
  },

  en: {
    nav: {
      about: "About",
      why: "Why Zen",
      how: "How It Works",
      format: "Store Format",
      gallery: "Gallery",
      investment: "Investment",
      contact: "Contact",
      cta: "Request information",
    },
    hero: {
      kicker: "Franchise · Essential living",
      title: "Open your Home Zen store.",
      subtitle:
        "The home, textile and linen franchise that unites design, quality and profitability.",
      ctaPrimary: "Request information",
      ctaSecondary: "Download brochure",
      scroll: "Scroll",
    },
    about: {
      kicker: "About Us",
      motto: "Less, but better.",
      title: "The beauty of essential living.",
      body: [
        "Home Zen was born from a simple idea: the home should be a place of calm, not excess. We select textiles, linens and décor built to last, ageing with grace.",
        "Natural materials, warm palettes, obsessive attention to detail. Every product is designed to bring balance to spaces and serenity to daily life.",
      ],
      values: [
        { title: "Essential living", text: "Fewer objects, more meaning. Spaces that breathe." },
        { title: "Natural materials", text: "Linen, cotton, ceramic and wood that tell a story." },
        { title: "Lasting quality", text: "Products made to stay with you for years, not seasons." },
        { title: "Attention to detail", text: "Every seam, every finish, crafted with precision." },
      ],
    },
    why: {
      kicker: "Why open a franchise",
      title: "A proven format, ready for you.",
      subtitle: "We support you at every stage with a sustainable model and a brand customers love.",
      items: [
        { icon: "Sparkle", title: "Recognisable brand", text: "A strong, coherent identity people love." },
        { icon: "Blueprint", title: "Proven format", text: "A tested and repeatable store model." },
        { icon: "Handshake", title: "Full support", text: "By your side from launch and every day after." },
        { icon: "Megaphone", title: "Marketing", text: "Ready-to-use campaigns, assets and strategy." },
        { icon: "GraduationCap", title: "Training", text: "Dedicated programmes for you and your team." },
        { icon: "SealCheck", title: "No experience needed", text: "We teach you everything you need to know." },
        { icon: "ShoppingBag", title: "Central purchasing", text: "Great terms and managed logistics." },
        { icon: "Storefront", title: "Visual merchandising", text: "Elegant layouts defined down to the detail." },
        { icon: "Headset", title: "Ongoing assistance", text: "A dedicated contact always available." },
      ],
    },
    how: {
      kicker: "How it works",
      title: "Six steps to your store.",
      steps: [
        { n: "01", title: "Request information", text: "Fill in the form and tell us your ambition." },
        { n: "02", title: "First meeting", text: "We get to know each other and assess the project." },
        { n: "03", title: "Location analysis", text: "We study the best spot for your store." },
        { n: "04", title: "Sign the contract", text: "Clear, transparent terms defined together." },
        { n: "05", title: "Training", text: "We prepare you and your team for launch." },
        { n: "06", title: "Store opening", text: "We inaugurate your new venture together." },
      ],
    },
    turnkey: {
      kicker: "Store format",
      title: "Shelving included. Brand included.",
      subtitle:
        "A store ready to open: modular Home Zen-branded fixtures, a layout studied down to the centimeter and hands-on assistance during setup.",
      bullets: [
        { title: "Modular shelving", text: "A scalable display system, adaptable to 80–120 sqm floorplans." },
        { title: "Branded graphics", text: "Header signs, banners and visual communication perfectly on-brand." },
        { title: "Tailored layout", text: "We design the arrangement together, based on your location." },
        { title: "Assembly & visual", text: "We stand by you from installation to product staging." },
      ],
      before: "Before",
      after: "After",
      dragHint: "Drag to compare",
      cta: "Request the fixtures quote",
    },
    investment: {
      kicker: "Investment",
      title: "A model designed to be sustainable.",
      body:
        "We built a balanced format where every item has a clear purpose and a measurable return. Total transparency, no surprises.",
      items: [
        { title: "Entry fee", text: "Clear access to the brand, know-how and the Home Zen method." },
        { title: "Royalties", text: "Aligned with results, so we grow together, fairly." },
        { title: "Training", text: "Included and continuous, for you and your team." },
        { title: "Assistance", text: "Constant support on management, purchasing and merchandising." },
      ],
      note: "We share the figures during the meeting, based on your specific project.",
    },
    gallery: {
      kicker: "Gallery",
      title: "Every corner, an experience.",
      categories: {
        camera: "Bedroom",
        bagno: "Bathroom",
        living: "Living",
        tessili: "Textiles",
        lenzuola: "Bed linen",
        tende: "Curtains",
        cuscini: "Cushions",
        complementi: "Décor",
      },
    },
    stats: {
      kicker: "The numbers",
      title: "Numbers that speak of trust.",
      items: [
        { value: 5000, suffix: "+", label: "Happy customers" },
        { value: 98, suffix: "%", label: "Satisfaction" },
        { value: 20, suffix: "", label: "Years of experience" },
        { value: 100, suffix: "%", label: "Dedicated support" },
      ],
    },
    testimonials: {
      kicker: "Testimonials",
      title: "Voices of those who chose Home Zen.",
      items: [
        { name: "Marco Bellini", role: "Franchisee · Milan", quote: "In one year the store became a local landmark. The support is constant and concrete." },
        { name: "Giulia Ferrara", role: "Franchisee · Bologna", quote: "I had no retail experience. Home Zen training made me confident from day one." },
        { name: "Alessandro Conti", role: "Franchisee · Turin", quote: "An elegant brand customers recognise and love. Central purchasing truly makes the difference." },
        { name: "Sara Moretti", role: "Franchisee · Florence", quote: "I found far more than a franchise: a method, a family and real profitability." },
      ],
    },
    faq: {
      kicker: "FAQ",
      title: "Frequently asked questions.",
      items: [
        { q: "How much space does the store need?", a: "The format is designed for about 80 to 120 sqm, in high-visibility, high-footfall locations." },
        { q: "How does product selection work?", a: "Through central purchasing: curated ranges, great terms and logistics managed by us." },
        { q: "How long does it take to open?", a: "It depends on the location, but our six-step process is designed to be fast and orderly." },
      ],
    },
    news: {
      kicker: "Magazine",
      title: "News, stories and downloads.",
      posts: [
        { tag: "News", title: "Home Zen opens in Verona", text: "The new store brings essential living to the heart of the city." },
        { tag: "Blog", title: "The art of natural linen", text: "Why we choose natural fibres and how they age with grace." },
        { tag: "Blog", title: "Designing spaces that breathe", text: "Five principles for a calmer, more essential home." },
      ],
      download: {
        title: "Download Area",
        text: "Download the full Home Zen franchise brochure in PDF format.",
        cta: "Download brochure",
      },
    },
    map: {
      kicker: "Store",
      title: "Where to find us.",
      subtitle: "You can find us in Milan, at our headquarters.",
      addressLabel: "Address",
      cta: "Get directions",
      stores: ["Milan"],
    },
    contact: {
      kicker: "Contact",
      title: "Let's start building your store.",
      subtitle: "Tell us about your project: we'll get back to you within 48 hours.",
      fields: {
        name: "Full name",
        phone: "Phone",
        email: "Email",
        province: "Province",
        budget: "Investment availability",
        message: "Your message",
      },
      budgetOptions: ["To be defined", "Up to €50,000", "€50,000 – €100,000", "Over €100,000"],
      privacy: "I have read and accept the Privacy Policy and data processing.",
      submit: "Send request",
      callback: "Request a callback",
      success: "Thank you! We're opening your email client to complete the request.",
      privacyError: "Please accept the Privacy Policy to continue.",
    },
    footer: {
      tagline: "Essential living, in franchise.",
      explore: "Explore",
      legal: "Legal",
      contactTitle: "Contact",
      social: "Follow us",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      rights: "All rights reserved.",
      vatLabel: "VAT",
    },
    floating: {
      call: "Call now",
      book: "Book a consultation",
      whatsapp: "Message us on WhatsApp",
    },
    affiliates: {
      linkLabel: "Franchisee Area",
      kicker: "Private area",
      title: "Welcome back, partner.",
      subtitle:
        "The private area for the Home Zen network: brochures, pricelists, monthly campaigns and internal updates.",
      logout: "Sign out",
      gate: {
        kicker: "Restricted access",
        title: "Home Zen Franchisee Area.",
        subtitle:
          "Enter the password you received via WhatsApp. Don't have it yet? Message our head office.",
        placeholder: "Password",
        submit: "Enter",
        error: "Wrong password. Try again or contact us.",
        contactHelp: "Don't have the password? Message us",
      },
      sections: {
        downloads: "Downloads & materials",
        campaigns: "This month's campaigns",
        news: "Internal news",
        kit: "Social Kit",
        purchasing: "Central purchasing",
      },
      downloads: {
        subtitle: "Official documents, always up to date.",
        items: [
          { key: "brochure", title: "Franchise brochure", desc: "The full document with format, materials, values and plan.", href: "/brochure-zen-home.pdf", available: true },
          { key: "pricelist", title: "Product pricelist", desc: "Reserved for franchisees. Available after signing.", available: false },
          { key: "contract", title: "Template contract", desc: "Editable franchise agreement draft.", available: false },
          { key: "media", title: "Media kit", desc: "Logo, palette, fonts and high-res imagery.", available: false },
        ],
      },
      campaigns: {
        subtitle: "Marketing assets ready to personalize.",
        items: [
          { tag: "Live", title: "Autumn · Essential living", text: "Window display + social campaign dedicated to seasonal natural materials." },
          { tag: "Upcoming", title: "Christmas · Gifts that last", text: "Linen boxsets + candles, launching in November." },
          { tag: "Always on", title: "Franchise Story", text: "Reel series with real franchisee stories to attract new partners." },
        ],
      },
      news: {
        subtitle: "Communications reserved for the network.",
        items: [
          { date: "07 · 2026", title: "New Home Zen store in Verona", text: "Opening confirmed on July 15. Prepare local communications." },
          { date: "07 · 2026", title: "Central purchasing update", text: "New linen assortments available from next Monday. Orders open." },
          { date: "06 · 2026", title: "Visual merchandising training", text: "Next webinar on 06/30 at 3 PM. Sign up via WhatsApp." },
        ],
      },
      kit: {
        subtitle: "12 posts + 15 stories + 3 reels ready for Instagram and TikTok.",
        cta: "Open the Social Kit",
      },
      purchasing: {
        subtitle: "Direct contact for orders and assortments.",
        emailLabel: "Orders email",
        whatsappLabel: "Central WhatsApp",
      },
    },
  },

  zh: {
    nav: {
      about: "关于我们",
      why: "为何选择 Zen",
      how: "合作流程",
      format: "门店格式",
      gallery: "作品展示",
      investment: "投资方案",
      contact: "联系我们",
      cta: "咨询详情",
    },
    hero: {
      kicker: "特许经营 · 极简生活",
      title: "开启您的 Home Zen 门店。",
      subtitle:
        "融合设计、品质与盈利能力的家居、织物与家纺特许经营品牌。",
      ctaPrimary: "咨询详情",
      ctaSecondary: "下载品牌手册",
      scroll: "向下滚动",
    },
    about: {
      kicker: "关于我们",
      motto: "少即是多。",
      title: "极简生活之美。",
      body: [
        "Home Zen 源于一个简单的理念:家应是宁静之所,而非繁复之地。我们精选可历经岁月、优雅陈化的织物、家纺与家居饰品。",
        "天然材质、温暖色调、极致细节。每一件产品都旨在为空间带来平衡,为生活注入静谧。",
      ],
      values: [
        { title: "极简生活", text: "更少器物,更多意义。让空间自在呼吸。" },
        { title: "天然材质", text: "亚麻、棉、陶瓷与木材,讲述真挚故事。" },
        { title: "持久品质", text: "为您陪伴数载而生,不为一时潮流。" },
        { title: "精工细节", text: "每一道缝线、每一处收边,皆经精心雕琢。" },
      ],
    },
    why: {
      kicker: "为何加盟",
      title: "成熟运营模式,为您而备。",
      subtitle: "以可持续的商业模型和深受顾客喜爱的品牌,伴您走好每一步。",
      items: [
        { icon: "Sparkle", title: "高辨识度品牌", text: "统一而鲜明的品牌形象,深入人心。" },
        { icon: "Blueprint", title: "成熟模式", text: "经市场验证、可复制的门店模型。" },
        { icon: "Handshake", title: "全方位支持", text: "从开业到日常运营,始终相伴。" },
        { icon: "Megaphone", title: "市场营销", text: "即用型营销活动、素材与策略。" },
        { icon: "GraduationCap", title: "专业培训", text: "为您与团队定制的培训课程。" },
        { icon: "SealCheck", title: "无需行业经验", text: "我们将传授您所需的一切。" },
        { icon: "ShoppingBag", title: "集中采购", text: "优惠条款,全程物流托管。" },
        { icon: "Storefront", title: "视觉陈列", text: "精致陈列,细节标准化管理。" },
        { icon: "Headset", title: "持续协助", text: "专属对接人,随时响应。" },
      ],
    },
    how: {
      kicker: "合作流程",
      title: "六步开启您的门店。",
      steps: [
        { n: "01", title: "咨询详情", text: "填写表单,分享您的商业构想。" },
        { n: "02", title: "初次洽谈", text: "深入沟通,共同评估项目。" },
        { n: "03", title: "选址分析", text: "为您甄选最佳门店位置。" },
        { n: "04", title: "签订合同", text: "条款清晰,合作透明。" },
        { n: "05", title: "系统培训", text: "全面赋能您和您的团队。" },
        { n: "06", title: "盛大开业", text: "携手启航,共创新征程。" },
      ],
    },
    turnkey: {
      kicker: "门店格式",
      title: "货架含品牌,一并交付。",
      subtitle:
        "开箱即用的门店:Home Zen 定制货架、精细至厘米的陈列方案,以及全程安装支持。",
      bullets: [
        { title: "模块化货架", text: "可扩展陈列系统,适配 80–120 平米空间。" },
        { title: "品牌视觉", text: "顶部标识、横幅与视觉传达,统一 Home Zen 品牌语言。" },
        { title: "定制布局", text: "根据您的门店位置,共同规划陈列布局。" },
        { title: "安装与陈列", text: "从组装到商品陈列,全程协助。" },
      ],
      before: "之前",
      after: "之后",
      dragHint: "拖动对比",
      cta: "获取货架报价",
    },
    investment: {
      kicker: "投资方案",
      title: "以可持续为核心的经营模型。",
      body:
        "我们构建了一个均衡的经营模型,每项投入皆有明确目标与可衡量回报。全程透明,毫无隐藏。",
      items: [
        { title: "加盟费", text: "获得品牌授权、专有技术与 Home Zen 方法论。" },
        { title: "权益分成", text: "与业绩挂钩,共同成长,公平共赢。" },
        { title: "培训体系", text: "持续赋能,覆盖您与团队。" },
        { title: "运营支持", text: "在管理、采购与陈列方面提供长期支持。" },
      ],
      note: "具体金额将根据您的项目在洽谈中详细沟通。",
    },
    gallery: {
      kicker: "作品展示",
      title: "每个角落,皆是体验。",
      categories: {
        camera: "卧室",
        bagno: "浴室",
        living: "客厅",
        tessili: "织物",
        lenzuola: "床品",
        tende: "窗帘",
        cuscini: "靠垫",
        complementi: "家居饰品",
      },
    },
    stats: {
      kicker: "数据见证",
      title: "数字诠释信任。",
      items: [
        { value: 5000, suffix: "+", label: "满意顾客" },
        { value: 98, suffix: "%", label: "满意度" },
        { value: 20, suffix: "", label: "年经验" },
        { value: 100, suffix: "%", label: "专属支持" },
      ],
    },
    testimonials: {
      kicker: "客户见证",
      title: "选择 Home Zen 的加盟商之声。",
      items: [
        { name: "Marco Bellini", role: "加盟商 · 米兰", quote: "一年间,门店已成为社区的标志。支持稳定而务实。" },
        { name: "Giulia Ferrara", role: "加盟商 · 博洛尼亚", quote: "此前毫无零售经验,Home Zen 的培训让我从第一天便自信独立。" },
        { name: "Alessandro Conti", role: "加盟商 · 都灵", quote: "顾客钟爱这一优雅品牌,集中采购让差异真正显现。" },
        { name: "Sara Moretti", role: "加盟商 · 佛罗伦萨", quote: "在这里,我找到了远超加盟的意义:方法、家族与切实的盈利。" },
      ],
    },
    faq: {
      kicker: "常见问题",
      title: "常见问题解答。",
      items: [
        { q: "门店需要多大面积?", a: "门店模型适用于约 80 至 120 平方米、高曝光、高客流的位置。" },
        { q: "产品如何选品?", a: "由集中采购中心统一执行:精选货品、优厚条款,物流由我们全程管理。" },
        { q: "开业需要多长时间?", a: "视选址而定,我们的六步流程旨在高效、有序地推进。" },
      ],
    },
    news: {
      kicker: "品牌资讯",
      title: "新闻、故事与下载。",
      posts: [
        { tag: "新闻", title: "Home Zen 维罗纳新店启幕", text: "全新门店将极简生活带入城市核心。" },
        { tag: "博客", title: "天然亚麻之美", text: "为何我们钟爱天然纤维,以及它们如何优雅陈化。" },
        { tag: "博客", title: "打造会呼吸的空间", text: "让家更宁静、更本真的五项原则。" },
      ],
      download: {
        title: "资料下载",
        text: "下载完整版 Home Zen 特许经营品牌手册(PDF)。",
        cta: "下载品牌手册",
      },
    },
    map: {
      kicker: "门店",
      title: "如何找到我们。",
      subtitle: "米兰总部,期待您的到访。",
      addressLabel: "地址",
      cta: "获取路线",
      stores: ["米兰"],
    },
    contact: {
      kicker: "联系我们",
      title: "让我们一起开启您的门店。",
      subtitle: "分享您的项目,我们将在 48 小时内与您联系。",
      fields: {
        name: "姓名",
        phone: "电话",
        email: "邮箱",
        province: "所在省份",
        budget: "投资预算",
        message: "您的留言",
      },
      budgetOptions: ["待定", "5 万欧元以下", "5 万 – 10 万欧元", "10 万欧元以上"],
      privacy: "我已阅读并同意《隐私政策》及数据处理条款。",
      submit: "提交申请",
      callback: "申请回电",
      success: "感谢!我们将为您打开邮件客户端以完成发送。",
      privacyError: "请先接受《隐私政策》以继续。",
    },
    footer: {
      tagline: "极简生活,特许经营。",
      explore: "浏览",
      legal: "法律",
      contactTitle: "联系",
      social: "关注我们",
      privacy: "隐私政策",
      cookie: "Cookie 政策",
      rights: "版权所有。",
      vatLabel: "增值税号",
    },
    floating: {
      call: "立即致电",
      book: "预约咨询",
      whatsapp: "通过 WhatsApp 联系",
    },
    affiliates: {
      linkLabel: "加盟商专区",
      kicker: "专属区域",
      title: "欢迎回来,合作伙伴。",
      subtitle:
        "Home Zen 加盟商专属区域:品牌手册、价目表、本月营销活动与内部资讯。",
      logout: "退出",
      gate: {
        kicker: "限制访问",
        title: "Home Zen 加盟商专区。",
        subtitle:
          "请输入通过 WhatsApp 收到的密码。尚未收到?请联系总部。",
        placeholder: "密码",
        submit: "进入",
        error: "密码错误,请重试或联系我们。",
        contactHelp: "没有密码?联系我们",
      },
      sections: {
        downloads: "资料下载",
        campaigns: "本月活动",
        news: "内部资讯",
        kit: "社媒资料包",
        purchasing: "集中采购",
      },
      downloads: {
        subtitle: "官方文件,持续更新。",
        items: [
          { key: "brochure", title: "加盟品牌手册", desc: "含格式、材质、价值观与完整方案的文件。", href: "/brochure-zen-home.pdf", available: true },
          { key: "pricelist", title: "产品价目表", desc: "加盟商专属,签约后开放。", available: false },
          { key: "contract", title: "合同模板", desc: "可编辑的加盟合同草案。", available: false },
          { key: "media", title: "媒体资料包", desc: "Logo、色板、字体与高清图片。", available: false },
        ],
      },
      campaigns: {
        subtitle: "可个性化的营销素材。",
        items: [
          { tag: "进行中", title: "秋季 · 极简生活", text: "橱窗与社媒活动,主打季节性天然材质。" },
          { tag: "即将开始", title: "圣诞 · 恒久的礼物", text: "亚麻礼盒与蜡烛,11 月推出。" },
          { tag: "长期在线", title: "加盟故事", text: "加盟商真实故事系列 Reel,用于招募新伙伴。" },
        ],
      },
      news: {
        subtitle: "面向加盟网络的内部通讯。",
        items: [
          { date: "07 · 2026", title: "维罗纳新店开业", text: "7 月 15 日开业确认,请准备本地宣传。" },
          { date: "07 · 2026", title: "集中采购更新", text: "下周一起,新款亚麻系列上架。订单已开放。" },
          { date: "06 · 2026", title: "视觉陈列培训", text: "下次网络研讨会 06/30 下午 3 点。通过 WhatsApp 报名。" },
        ],
      },
      kit: {
        subtitle: "为 Instagram 与 TikTok 准备的 12 条帖子 + 15 条 Story + 3 条 Reel。",
        cta: "打开社媒资料包",
      },
      purchasing: {
        subtitle: "订单与商品的直接联系方式。",
        emailLabel: "订单邮箱",
        whatsappLabel: "总部 WhatsApp",
      },
    },
  },
};
